export const flattenItems = <T extends { children?: ReadonlyArray<T> }>(
  items: ReadonlyArray<T>,
): T[] => items.flatMap((item) => [item, ...(item.children ? flattenItems(item.children) : [])]);

